import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';

import { AnySchemaComponent } from './AnySchemaComponent';

interface ArticleSchemaProps {
  url: string;
  headline: string;
  description: string;
  articleBody: string;
  imageUrl: string;
  publishedDate: string;
  modifiedDate: string;
  author: string;
}

export const ArticleSchema = ({
  url,
  headline,
  description,
  articleBody,
  imageUrl,
  publishedDate,
  modifiedDate,
  author,
}: ArticleSchemaProps): JSX.Element => {
  const tishmanLogo = useStaticQuery<Queries.TishmanLogoQueryQuery>(graphql`
    query TishmanLogoQuery {
      file(name: { eq: "tishman-favicon" }) {
        childImageSharp {
          fixed {
            height
            width
            src
          }
        }
      }
    }
  `);

  const logoData =
    tishmanLogo.file &&
    tishmanLogo.file?.childImageSharp &&
    tishmanLogo.file?.childImageSharp.fixed
      ? tishmanLogo.file.childImageSharp.fixed
      : { src: '', width: '', height: '' };

  const schemaString = `
    {
      "@context": "https://schema.org",
      "@type": ["BlogPosting", "Article"],
      "mainEntityOfPage": {
        "@type": "WebPage",
        "@id": "${url}"
      },
      "headline": "${headline}",
      "description": "${description}",
      "articleBody": "${articleBody}",
      "speakable":
      {
        "@type": "SpeakableSpecification",
        "xpath": [
          "/html/head/title",
          "/html/head/meta[@name='description']/@content"
        ]
      },
      "image": [
        "${imageUrl}"
       ],
      "datePublished": "${publishedDate}",
      "dateModified": "${modifiedDate}",
      "author": {
        "@type": "Person",
        "name": "${author}"
      },
       "publisher": {
        "@type": "Organization",
        "name": "Rockefeller Center",
        "logo": {
          "@type": "ImageObject",
          "url": "${logoData.src}",
          "width": "${logoData.width}",
          "height": "${logoData.height}"
        }
      }
    }
  `;

  return <AnySchemaComponent schemaString={schemaString} />;
};
